export enum SETTING_TYPE_ALIAS {
  immediate = 'immediate',
  hourly = 'hourly',
  time_frame = 'timeframe'
}

export const INTERVAL_LIMIT = 2

export const WEEKS: Array<{ id: number; label: string }> = [
  {
    id: 1,
    label: 'Monday'
  },
  {
    id: 2,
    label: 'Tuesday'
  },
  {
    id: 3,
    label: 'Wednesday'
  },
  {
    id: 4,
    label: 'Thursday'
  },
  {
    id: 5,
    label: 'Friday'
  },
  {
    id: 6,
    label: 'Saturday'
  },
  {
    id: 0,
    label: 'Sunday'
  },
]

export enum WEEKS_ARRAY {
  'Sunday' = 0,
  'Monday' = 1,
  'Tuesday' = 2,
  'Wednesday' = 3,
  'Thursday' = 4,
  'Friday' = 5,
  'Saturday' = 6
}